var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Address-Popup",
    transform: "translate(-565.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(565.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5037",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 17.000000) rotate(-90.000000) translate(-17.000000, -17.000000) translate(10.151338, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,8.44591346 C5.08922466,7.46278112 4.69872567,7.38639566 5.75552303,6.39114539 C6.81315186,5.39642199 7.86911776,4.40117172 8.82281294,3.36693336 C9.14874887,3.013933 9.86464385,2.89486123 10.4217282,3.10139279 C10.9779811,3.30792434 11.1658932,3.76155615 10.8399572,4.11402964 C10.8366314,4.11824457 10.8291481,4.12509383 10.8258223,4.12930876 C9.83304802,5.14879487 8.94171303,6.20674222 8.05287245,7.26521643 C7.16236893,8.32369065 6.26022484,9.37794993 5.40214862,10.4485421 C5.00387487,10.94485 4.04685382,11.1424249 3.26360982,10.8905828 C2.96511238,10.7946932 2.73479541,10.6466438 2.58679389,10.4733048 L2.56517569,10.4485421 L-2.85766647,4.12930876 C-3.16614155,3.76998601 -2.95661131,3.32004226 -2.38954931,3.1245749 C-1.85325167,2.93964486 -1.18724484,3.05081363 -0.855488626,3.36693336 L4,8.44591346 Z",
    id: "Fill-1-Copy-21",
    transform: "translate(4.000000, 7.000000) rotate(-90.000000) translate(-4.000000, -7.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69732422,8.44591346 C10.7865489,7.46278112 10.3960499,7.38639566 11.4528473,6.39114539 C12.5104761,5.39642199 13.566442,4.40117172 14.5201372,3.36693336 C14.8460731,3.013933 15.5619681,2.89486123 16.1190524,3.10139279 C16.6753053,3.30792434 16.8632174,3.76155615 16.5372814,4.11402964 C16.5339556,4.11824457 16.5264723,4.12509383 16.5231465,4.12930876 C15.5303722,5.14879487 14.6390373,6.20674222 13.7501967,7.26521643 C12.8596931,8.32369065 11.9575491,9.37794993 11.0994728,10.4485421 C10.7011991,10.94485 9.74417803,11.1424249 8.96093404,10.8905828 C8.6624366,10.7946932 8.43211962,10.6466438 8.28411811,10.4733048 L8.26249991,10.4485421 L2.83965774,4.12930876 C2.53118267,3.76998601 2.74071291,3.32004226 3.30777491,3.1245749 C3.84407254,2.93964486 4.51007938,3.05081363 4.84183559,3.36693336 L9.69732422,8.44591346 Z",
    id: "Fill-1-Copy-22",
    transform: "translate(9.697324, 7.000000) scale(-1, 1) rotate(-90.000000) translate(-9.697324, -7.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIc);
export default __webpack_public_path__ + "static/media/close-ic.826795809e4e86cb42d396de67d8f2c8.svg";
export { ForwardRef as ReactComponent };